module.exports = "/lucky-balls/img/infobox/info_Box_034.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_034.png
// module id = 1099
// module chunks = 0